import BaseModel from '../base/BaseModel.model';
export default class ProposalDocument extends BaseModel {
   public isFileToChangeStatusAprobation:boolean;
   public documentId?:number;
   public document:any;
   public contentTypeId?:number;

    init(){
        this.documentId = 0;  
        this.contentTypeId = null;
    }
}